module.exports = require('../package.json').version;



// WEBPACK FOOTER //
// ./node_modules/web3/packages/web3-providers-ws/node_modules/websocket/lib/version.js